import React, { useMemo } from 'react';
import { singleStoryStyles } from '../../pages/style';

const StoryDisplay = ({ story, onClick, onLoad, eager = false }) => {
	const classes = singleStoryStyles();
	// Per-thumbnail random rotation direction for review-type hovers, stable
	// across re-renders (so the tile doesn't flicker if it re-renders mid-hover).
	const rotateDeg = useMemo(() => (Math.random() < 0.5 ? -17 : 17), []);

	// Only render the actual <img> once the loader has unlocked this slot.
	// Returning null keeps the page from being padded by tall placeholders.
	if (!eager) return null;

	const handleSettled = () => {
		if (onLoad) onLoad();
	};

	// Prefer the API's resized thumbnail (~800 px / WebP, ~55× smaller than
	// the original). Fall back to `image` for older API responses or stories
	// where the resize wasn't generated.
	const src = story.thumbnail || story.image;

	// Reviews tilt on hover; podcasts are waveforms (no square slot, no skeleton);
	// everything else uses the default scale-on-hover storyImage style.
	const isReview = story?.type === 'Review';
	const isPodcast = story?.type === 'Podcast';
	const className = isReview
		? classes.storyImageReview
		: isPodcast
			? classes.storyImagePodcast
			: classes.storyImage;

	return (
		<img
			className={className}
			alt={story?.title || ''}
			// No explicit height attr: the container hugs the image's natural
			// aspect. The page-level useTopDownPreloader hook only mounts this
			// <img> when its bytes are already fetched AND decoded, so the
			// element paints at final dimensions on first frame.
			width={400}
			src={src}
			fetchpriority="high"
			// "sync" decode: bytes are already in cache + decoded by the
			// preloader, so this is essentially free, but it avoids the
			// async-decode 0-height blink that was causing the home-page
			// position jumps.
			decoding="sync"
			onClick={() => onClick && onClick()}
			// CSS variable consumed by storyImageReview's :hover rotate.
			// The other variants ignore it.
			style={isReview ? { '--rotate-deg': `${rotateDeg}deg` } : undefined}
			onLoad={handleSettled}
			onError={handleSettled}
		/>
	);
};

export default StoryDisplay;
